import { Typography } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCartFunctions } from "../services/ApiServices/CartProductService";
//import { UpdateProductQuantity, useCartFunctions } from "../services/ApiServices/CartProductService";
import { formatPrice } from "../services/formatPrice";

type QuantityButtonProps = {
    cartProductId: string,
    quan: number,
    totalPrice: number,
    setProductTotalPrice: (totalprice: number) => void,
    selected: boolean,
    calculateTotalPrice: (a: number) => void,
    price: number
    UpdateProductQuantity: (updateQuantity: any) => Promise<void>
};
 
export function QuantityButton({ cartProductId, UpdateProductQuantity, quan, totalPrice, price, setProductTotalPrice, selected, calculateTotalPrice }: QuantityButtonProps) {
  
  const [productTotalPriceState, setProductTotalPriceState] = useState(totalPrice);
  const [quantity, setQuantity] = useState(quan);
  const [errorMessage, setErrorMessage] = useState("");

  const fetchUpdateQuantity = async (updateQuantity: number) => {
    try{
      await UpdateProductQuantity({ cartProductId: cartProductId, quantity: updateQuantity });
    }
    catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        // If the error response contains a message, set it as the error message
        setErrorMessage(error.response.data.message);
      } else {
        // If the error is something else, set a generic error message
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  const increaseQuantity = () => {
    const updateQuantity = quantity + 1
    setQuantity(updateQuantity);
    setProductTotalPriceState(calculatePrice(updateQuantity, price));
    setProductTotalPrice(calculatePrice(updateQuantity, price));
    if(selected){
        calculateTotalPrice(price)
    }
    fetchUpdateQuantity(updateQuantity);
  }

  const changeQuantity = (quanti: number) => {
    if(!Number.isInteger(quanti)) return
    const oldQuantity = quantity
    setQuantity(quanti);
    setProductTotalPriceState(calculatePrice(quanti, price));
    setProductTotalPrice(calculatePrice(quanti, price));
    if(selected){
        calculateTotalPrice(-(oldQuantity-quanti) * price)

        //console.log(oldQuantity-quanti)
    }
    fetchUpdateQuantity(quanti);
  }

  const decreaseQuantity = () => {
    if(quantity <= 1) return
    const updateQuantity = quantity - 1
    setQuantity(updateQuantity);
    setProductTotalPriceState(calculatePrice(updateQuantity, price));
    setProductTotalPrice(calculatePrice(updateQuantity, price));
    if(selected){
        calculateTotalPrice(-price)
    }
    fetchUpdateQuantity(updateQuantity);  
  }

  const calculatePrice = (quantity: number, price:number) => {
    return quantity * price
  }

  useEffect(() => {
      setQuantity(quan)
      setProductTotalPriceState(calculatePrice(quan, price));
      setProductTotalPrice(calculatePrice(quan, price));
  }, [quan])

  return (
      <div className="flex justify-between">
            <Typography color="red" placeholder={""}>{formatPrice(productTotalPriceState)}</Typography>
            <div className="flex items-center">
              <button className="py-0 px-2 border border-gray-500 text-lg" onClick={() => decreaseQuantity()}>-</button>
              <input className="border w-12 border-gray-500 text-lg text-center" value={quantity} onChange={(e) => changeQuantity(Number(e.target.value))}/>
              <button className="py-0 px-2 border border-gray-500 text-lg" onClick={() => increaseQuantity()}>+</button>
            </div>
        </div>
);
}
